import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Illustration, IllustrationComponent, PageComponent } from '@ftr/foundation'

@Component({
  selector: 'ftr-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  imports: [RouterModule, IllustrationComponent, PageComponent],
})
export class NotFoundComponent {
  readonly illustration = Illustration
}
